import makeValidationSchema from './TransportationDetailsMakeValidationSchema'
import { useTranslation } from 'cng-web-lib'
import React from 'react'
import Namespace from 'src/constants/locale/Namespace'
import AesShipmentKeys from 'src/constants/locale/key/AesShipment'
import { Card, CardContent, Grid, Tooltip } from '@material-ui/core'
import {
  components,
} from 'cng-web-lib'
import TransportationDetailsFormProperties from './TransportationDetailsFormProperties'

const {
  button: { CngIconButton }
} = components

const { initialValues } = TransportationDetailsFormProperties.formikProps

function TransportationDetailsEntry({
  index,
  isLast,
  onAddTransportationDetails,
  onDeleteTransportationDetails,
  transportationDetails,
  showNotification
}) {

  return (

    <Grid container spacing={2}>
      <Grid item xs={12} md>
        <TransportationDetailsFormProperties.Fields index={index} showNotification={showNotification} />
      </Grid>
      <Grid item xs={12} md='auto'>
        <Grid container spacing={1}>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title='Add new'>
              <span>
                <CngIconButton
                  icon={['fal', 'plus']}
                  onClick={() => onAddTransportationDetails(initialValues)}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title='Clone'>
              <span>
                <CngIconButton
                  icon={['fal', 'copy']}
                  onClick={() => onAddTransportationDetails({ ...transportationDetails, id: undefined })}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          {!isLast && (
            <Grid item xs='auto'>
              <Tooltip placement='bottom' title='Delete'>
                <span>
                  <CngIconButton
                    icon={['fal', 'trash']}
                    onClick={() => onDeleteTransportationDetails(transportationDetails)}
                    size='small'
                    type='outlined'
                  />
                </span>
              </Tooltip>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default TransportationDetailsEntry
